export const ADD_REMAINDER='ADD_REMAINDER'
export const REMOVE_REMAINDER='REMOVE_REMAINDER'
export const CLEAR_REMAINDERS='CLEAR_REMAINDERS'